import * as Yup from 'yup';

export const SendFeedbackSchema = Yup.object().shape({
  feedbackType: Yup.string().label('Type of feedback').required(),
  subject: Yup.string()
    .label('Subject')
    .max(150, 'Maximum 150 characters')
    .required(),
  description: Yup.string()
    .label("What's on your mind")
    .max(500, 'Maximum 500 characters')
    .required()
});
